@layer refine.base {
  /* ========================================
       Base Styles & Defaults
       ======================================== */

  :host {
    --_size: var(--radio-size, var(--size-5));
    --_font-size: var(--radio-font-size, var(--text-sm));
    --_bg: var(--radio-bg, var(--color-contrast-200));
    --_border: var(--radio-border-color, var(--color-contrast-300));

    display: inline-flex;
    flex-wrap: wrap;
    gap: var(--_gap, var(--size-2));
    align-items: center;
    min-height: var(--_touch-target);
    cursor: pointer;
    user-select: none;
  }

  .radio-wrapper {
    position: relative;
    display: block;
    flex-shrink: 0;
    width: var(--_size);
    height: var(--_size);
  }

  .circle {
    position: relative;
    box-sizing: border-box;
    width: var(--_size);
    height: var(--_size);
    background: var(--_bg);
    border: var(--border-2) solid var(--_border);
    border-radius: 50%;
    transition:
      background var(--transition-normal),
      border-color var(--transition-normal),
      box-shadow var(--transition-normal);
  }

  /* ========================================
       Focus State
       ======================================== */

  :host(:focus-visible) .circle {
    box-shadow: var(--_focus-shadow);
  }

  /* ========================================
       Inner Dot
       ======================================== */

  .dot {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 50%;
    height: 50%;
    background: var(--_dot-color);
    border-radius: 50%;
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.5);
    transition:
      opacity var(--transition-spring),
      transform var(--transition-spring);
  }

  /* ========================================
       Label
       ======================================== */

  .label {
    font-size: var(--_font-size);
    color: var(--color-contrast);
  }

  /* ========================================
       Helper / Error Text
       ======================================== */

  .helper-text[hidden] {
    display: none;
  }

  .helper-text {
    width: 100%;
    padding-inline-start: calc(var(--_size) + var(--size-2));
    font-size: var(--text-xs);
    line-height: var(--leading-tight);
    color: color-mix(in oklch, var(--color-contrast-500) 80%, var(--color-canvas));
  }

  .helper-text[role='alert'] {
    color: var(--color-error);
  }
}

@layer refine.overrides {
  /* Map theme variables to radio-specific variables */
  :host {
    --_active-bg: var(--radio-checked-bg, var(--_theme-base));
    --_dot-color: var(--radio-color, var(--_theme-contrast));
    --_focus-shadow: var(--_theme-shadow);
  }

  /* ========================================
       Checked State
       ======================================== */

  :host([checked]) .circle {
    background: var(--_active-bg);
    border-color: var(--_active-bg);
  }

  :host([checked]) .dot {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}
